import { LoadUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/trade/load_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { loadStatusLabels } from '../enumLabels';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type LoadUpdatedDetailProps = {
  event: LoadUpdatedEvent;
};

export const LoadUpdatedDetail = ({ event }: LoadUpdatedDetailProps) => {
  const t = useTranslations();
  const previous = event.previousLoad;
  const current = event.updatedLoad;

  if (!previous || !current) {
    return (
      <Col className="@LoadUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.eventLogs.noDataAvailable}</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'status',
      label: t.eventLogs.load.fields.status,
      previous: loadStatusLabels[previous.status],
      current: loadStatusLabels[current.status],
    },
    {
      field: 'bookingId',
      label: t.eventLogs.load.fields.bookingId,
      previous: previous.bookingId,
      current: current.bookingId,
    },
    {
      field: 'salesOrderId',
      label: t.eventLogs.load.fields.salesOrderId,
      previous: previous.salesOrderId,
      current: current.salesOrderId,
    },
    {
      field: 'facilityId',
      label: t.eventLogs.load.fields.facilityId,
      previous: previous.facilityId,
      current: current.facilityId,
    },
    {
      field: 'containerNumber',
      label: t.eventLogs.load.fields.containerNumber,
      previous: previous.containerNumber,
      current: current.containerNumber,
    },
    {
      field: 'sealNumber',
      label: t.eventLogs.load.fields.sealNumber,
      previous: previous.sealNumber,
      current: current.sealNumber,
    },
    {
      field: 'driverName',
      label: t.eventLogs.load.fields.driverName,
      previous: previous.driverName,
      current: current.driverName,
    },
    {
      field: 'truckNumber',
      label: t.eventLogs.load.fields.truckNumber,
      previous: previous.truckNumber,
      current: current.truckNumber,
    },
  ];

  return (
    <Col className="@LoadUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.eventLogs.load.sectionTitle}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id} />
          <FieldDisplay
            label={t.eventLogs.load.documentNumber}
            value={String(current.documentNumber)}
          />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          {t.eventLogs.load.changes}
        </span>
        <DiffViewer
          diffs={diffs}
          previousLabel={t.eventLogs.load.before}
          currentLabel={t.eventLogs.load.after}
        />
      </Col>
    </Col>
  );
};
